/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export type AzureMigrationModalScreen =
    | 'start'
    | 'azureSubscription'
    | 'exportApps'
    | 'emailCollaborators'
    | 'emailCollaboratorsSummary'
    | 'exportAppsSummary'
    | 'chooseCsAccount'
    | 'createCsAccount'
    | 'finish';

/**
 * MultiRegionMigrationModal modal steps
 */
export enum MultiRegionMigrationSteps {
    start = 0,
    emailCollaborators = 1,
    exportApps = 2,
    regionalMigration = 3,
    chooseAusCsAccount = 4,
    chooseEuCsAccount = 5,
    chooseUsCsAccount = 6,
    chooseCsAccount = 7,
    createCsAccount = 8,
    finish = 9
}
